
export default {

  SET_PDF_CONFIGURATIONS: (state, payload) => state.pdfConfigurations = payload,

}